module.exports = __webpack_public_path__ + "img/yg-logo.33d8fb84.svg";